import { useAppStore } from "@/stores/app";

export function useBrandText(namespace: string, i18nPrefix: string, t: (key: string) => string) {
  const { appTexts } = useAppStore();

  return (key: string): string => {
    const group = appTexts?.[namespace] as Record<string, unknown> | undefined;
    const customText = group?.[key];
    const sanitizedText = String(customText ?? "").trim();

    if (sanitizedText) {
      return sanitizedText;
    }

    return t(`${i18nPrefix}.${key}`);
  };
}
